import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import {
  callApi,
  fnGetDataSet,
  fnSave,
  fnGetTableById,
} from "@shared/api/restApi"; // BackEnd API
import {
  getInitForm,
  getInitFormData,
  getNoSlip,
  getTablebySql,
  applySlip,
  getconfigData,
} from "@shared/utils/CommonUtils";
import { showPopupModal } from "@widgets/CommonModal";
import { showDialog } from "@widgets/CommonDialog";
import { global, globalMenu, useMenuStore } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { ChatScreenSelection, menuInfo } from "@shared/type/CommonType";
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizable from "@shared/components/SnResizable";
import usePanelSizes from "@shared/hooks/usePanelSizes";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { dateToString, formatYyyyMMdd } from "@shared/utils/DateUtils";
import { RowNode } from "ag-grid-community";
import SnResizeBar from "@shared/components/SnResizeBar";
import SN_PRD_WMO_REG_002_TEX_POP_001 from "./SN_PRD_WMO_REG_002_TEX_POP_001";
import SN_PRD_WMO_REG_002_TEX_POP_002 from "./SN_PRD_WMO_REG_002_TEX_POP_002";

interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string;

  [key: string]: any;
}

const CHAT_SELECTION_KEYS = ["cd_item", "no_wo", "no_po", "st_wo"] as const;

const toChatSelection = (row: RowData | undefined | null) => {
  if (!row) {
    return undefined;
  }

  const selection: ChatScreenSelection = {};
  CHAT_SELECTION_KEYS.forEach((key) => {
    const value = row[key];
    if (typeof value === "string") {
      const cleanValue = value.trim();
      if (cleanValue) selection[key] = cleanValue;
    } else if (typeof value === "number" || typeof value === "boolean") {
      selection[key] = value;
    }
  });

  return Object.keys(selection).length > 0 ? selection : undefined;
};

const SN_PRD_WMO_REG_002_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const [isNewRow, setIsNewRow] = useState(false);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const isRestoring = useRef(false);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)

    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global();
  const { menuItems } = useMenuStore();
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const selectedTabPage = useRef<string>("1");
  const [_qtdy04_visible, set_qtdy04_visible] = useState(true);
  const _dt = useRef<any>();
  const noLineP = useRef<number>(0);
  const isYnEnd = useRef<boolean>(true);
  const _nm_rout_old = useRef<string>("");
  const _cd_item_old = useRef<string>("");
  const [gridFocus, setGridFocus] = useState(false);
  useRef<string>("");
  const [activeTab, setActiveTab] = useState("1");
  const focusKeyRef = useRef<{
    no_wo?: string;
  } | null>(null);
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);

  const woInfoRef = useRef({ cd_wo: "", st_wo: "" });
  const isProgrammaticChangeRef = useRef(false);
  //#endregion
  const cd_menu = Menuprops.cd_menu || "SN_PRD_WMO_REG_002_TEX";
  const publishChatSelection = (row: RowData | undefined | null) => {
    const selection = toChatSelection(row);
    if (selection) {
      globalMenu.getState().setChatScreenSelection(cd_menu, selection);
    } else {
      globalMenu.getState().clearChatScreenSelection(cd_menu);
    }
  };
  const defaultSize = { panel1height: "45.5%", panel2height: "45.5%" };
  const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        const popup_apply1 = [
          { target: "cd_wh_rcv", source: "cd_wh" },
          { target: "nm_wh", source: "nm_wh" },
        ];

        const grid1 = rtn.grid.grid1.map((col: any) => {
          let newCol = { ...col };
          if (col.cd_column === "cd_wh_rcv") {
            newCol.popup_apply = popup_apply1;
          }
          return newCol;
        });
        setColums({
          grid1: grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);
  useEffect(() => {
    return () => {
      globalMenu.getState().clearChatScreenSelection(cd_menu);
    };
  }, [cd_menu]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const rtn: any = await getInitFormData();

        const sqlQuery = {
          sql: "select cd_wo, case when coalesce(yn_autorel,'N') = 'Y' then 'R' else 'F' end as st_wo from mas_wotype where cd_firm = :cd_firm and yn_default = 'Y' limit 1",
          cd_firm: userInfo.cd_firm,
        };
        const result = await getTablebySql(sqlQuery);
        if (result.length > 0) {
          woInfoRef.current = {
            cd_wo: result[0].cd_wo,
            st_wo: result[0].st_wo,
          };
        }
      } catch (error) {}
    };
    fetchData();
  }, [userInfo]);

  useEffect(() => {
    if (gridFocus) {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }
  }, [gridFocus]);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
  }));
  //#region OnSearch
  const onSearch = async () => {
    try {
      const params = {
        id: "sn_prd_wmo_reg_002_tex_01",
        params: searchRef.current.getFormdata(),
      };
      setSelectedDocu("");
      publishChatSelection(null);

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });

      setGridFocus(true);
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };
  //#region OnInsert
  const onInsert = async () => {
    try {
      const searchForm = searchRef.current.getFormdata();
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        cd_dept: userInfo.cd_dept,
        no_wo: "",
        cd_biz: userInfo.cd_biz,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        dt_wo: todayform,
        tp_wo: searchForm.tp_wo,
        dt_start: todayform,
        dt_end: todayform,
        fg_wo: "ETC",
        qt_work: 0,
        qt_rcv: 0,
        qt_req: 0,
        qt_wo: 1,
        qt_divide: 1,
        cd_wo: woInfoRef.current.cd_wo,
        st_wo: woInfoRef.current.st_wo,
        _isNew: true,
      };
      if (searchForm.tp_wo === "") {
        showDialog("alter", "공정경로유형을 선택하시기 바랍니다.");
        return;
      }
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  //#region OnDelete
  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0) return;
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    const rowData = selectedRows.data;

    if (rowData._isNew) {
      gridRefs.current["grid2"].current?.deleteAllRows();
      gridRefs.current["grid3"].current?.deleteAllRows();
      gridRefs.current["grid1"].current?.deleteSelectedRows();
      publishChatSelection(null);
      return;
    }
    const footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const footerData3 = gridRefs.current["grid3"].current?.getFooterData();
    const qtWork = footerData2?.qt_work;

    const noWoreq = selectedRows.data.no_woreq ?? "";
    const noLineWoreq = selectedRows.data.no_line_woreq;
    if (selectedRows.data.no_mrp) {
      showDialog(
        "error",
        "MRP 또는 MPS 확정으로 자동 생성된 건은 삭제할 수 없습니다."
      );
      return;
    }
    if (
      selectedRows.data.no_mrp === "R" &&
      selectedRows.data.yn_autorel === "N"
    ) {
      showDialog(
        "error",
        "발행된 작업지시 정보입니다.\n발행 취소 후 삭제 해주시기 바랍니다."
      );
      return;
    }
    if (selectedRows.data.qt_work !== 0) {
      showDialog("error", "진행된 수량이 존재합니다.");
      return;
    }
    if (qtWork !== null && qtWork !== 0) {
      showDialog("error", "공정 진행된 수량이 존재합니다.");
      return;
    }
    /*  if (footerData3.qt_use !== null && footerData3.qt_use !== 0) {
      showDialog(
        "error",
        "투입된 자재가 존재합니다.\n투입전표 삭제 후 진행해주시기 바랍니다."
      );
      return;
    }
    if (
      (footerData3.qt_isu !== null && footerData3.qt_isu !== 0) ||
      (footerData3.qt_isu_bf !== null && footerData3.qt_isu_bf !== 0)
    ) {
      showDialog(
        "error",
        "출고된 자재가 존재합니다.\n출고전표 삭제 후 진행해주시기 바랍니다."
      );
      return;
    }
    if (
      (footerData3.qt_req_bf !== null && footerData3.qt_req_bf !== 0) ||
      (footerData3.qt_req !== null && footerData3.qt_req !== 0)
    ) {
      showDialog(
        "error",
        "출고요청된 자재가 존재합니다.\n출고요청전표 삭제 후 진행해주시기 바랍니다."
      );
      return;
    }*/
    if (selectedRows.data.st_wo !== "R" && selectedRows.data.st_wo !== "F") {
      showDialog("error", "공정 진행된 건이 존재합니다.");
      return;
    }
    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }
    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid3"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();
    publishChatSelection(null);
    const realDeletedRows =
      gridRefs.current["grid1"].current?.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid1"].current?.resetUpdate();
      return;
    }
    const isSaved = await onSave();
    if (isSaved) {
      if (noWoreq === "") return;
      const params = {
        cd_firm: userInfo.cd_firm,
        no_woreq: noWoreq,
        no_line_woreq: noLineWoreq,
      };
      await callApi("SN_PRD_WMO_REG_01_btnOndelete", params);
    }
  };
  const onPrint = async () => {
    gridRefs.current["grid1"].current?.stopEditing();
    gridRefs.current["grid2"].current?.stopEditing();
    const grid1 = gridRefs.current["grid1"].current?.focusedRowNode();
    const grid2 = gridRefs.current["grid2"].current?.focusedRowNode();
    gridRefs.current["grid1"].current?.resetUpdate();
    gridRefs.current["grid2"].current?.resetUpdate();
    // 결과 객체 반환
    return {
      cd_firm: userInfo.cd_firm,
      no_wo: grid1.data.no_wo,
      cd_op: grid2.data.cd_op,
    };
  };
  //#region OnDeleteRow
  const onDeleteRow = async () => {
    let rowCount;
    if (selectedTabPage.current === "1")
      rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    else rowCount = gridRefs.current["grid3"].current?.getDisplayedRowCount();
    if (rowCount < 0) return;
    const selectedRows2 =
      gridRefs.current["grid1"].current?.getSelectedRows?.() || [];
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    const hasSavedRow = selectedRows2.some(
      (row: any) => row.state !== "insert"
    );
    if (hasSavedRow) {
      await showDialog("alert", "저장된 데이터는 삭제할 수 없습니다.");
      return;
    }
    const st_wo = selectedRows.data.st_wo;
    let footerData2;
    if (selectedTabPage.current === "1")
      footerData2 = gridRefs.current["grid2"].current?.getFooterData();
    const qt_work = footerData2?.qt_work;
    if (selectedRows.data.no_wo !== "") {
      if (st_wo === "C") {
        showDialog("error", "지시상태 마감의 경우 행추가 하실 수 없습니다.");
        return;
      } else if (st_wo === "R") {
        if (
          selectedTabPage.current === "1" &&
          selectedRows.data.yn_autorel === "Y" &&
          qt_work > 0
        ) {
          showDialog(
            "error",
            "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
          );
          return;
        } else if (selectedRows.data.yn_autorel === "N") {
          showDialog(
            "error",
            "발행된 작업지시므로 행추가/행삭제 할 수 없습니다."
          );
          return;
        }
      }
    }

    if (selectedTabPage.current === "1") {
      gridRefs.current["grid2"].current?.deleteSelectedRows();
    } else {
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    }
  };
  //#region onAddRow
  const onAddRow = async () => {
    try {
      const row = gridRefs.current["grid1"].current?.focusedRowNode();
      let selectedRows = gridRefs.current["grid1"].current.getSelectedRows();
      const allRowData: any[] = []; // 라인에 있는 데이터들
      const allRowData2: any[] = []; // 라인에 있는 데이터들
      gridRefs.current["grid2"].current?.forEachFilteredNode((node: any) => {
        allRowData.push(node.data);
      });
      gridRefs.current["grid3"].current?.forEachFilteredNode((node: any) => {
        allRowData2.push(node.data);
      });
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      const maxNoLine2 =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      if (selectedTabPage.current === "1") {
        const newRow = {
          qt_wo: row.data.qt_wo,
          qt_divide: row.data.qt_divide,
          cd_firm: userInfo.cd_firm,
          dt_dlv: todayform,
          no_line: maxNoLine + 1,
          yn_work: "Y",
          st_proc: woInfoRef.current.st_wo,
        };
        gridRefs.current["grid2"].current?.addRow(newRow);
      } else {
        if (selectedRows.length === 0) return;

        const hasSavedRow = selectedRows.some(
          (row: any) => row.state !== "insert"
        );

        if (hasSavedRow) {
          await showDialog("alert", "저장된 데이터는 추가할 수 없습니다.");
          return;
        }
        const newRow = {
          qt_wo: row.data.qt_wo,
          qt_divide: row.data.qt_divide,
          cd_firm: userInfo.cd_firm,
          dt_dlv: todayform,
          no_line: maxNoLine2 + 2,
          yn_bf: "Y",
        };
        gridRefs.current["grid3"].current?.addRow(newRow);
      }
    } catch (error: any) {}
  };
  //#region InitnewRowH
  /*const onBeforeAddRowH = (newRow: RowData): boolean => {
    try {
      const prdWoTexChanges = gridApiRef1.current.getChange().insert;
      const searchParam = searchRef.current.getFormdata();
      if (prdWoTexChanges.length > 0) return false;

      const updatedRow = {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        cd_dept: userInfo.cd_dept,
        no_wo: "",
        cd_biz: userInfo.cd_biz,
        cd_gp: userInfo.cd_gp,
        cd_emp: userInfo.cd_emp,
        dt_wo: todayform,
        tp_wo: searchParam.tp_wo,
        dt_start: todayform,
        dt_end: todayform,
        fg_wo: "ETC",
        qt_work: 0,
        qt_rcv: 0,
        qt_req: 0,
        qt_wo: 1,
        qt_divide: 1,
        no_line_so: 0,
        cd_wo: woInfoRef.current.cd_wo,
        st_wo: woInfoRef.current.st_wo,
      };

      Object.assign(newRow, updatedRow);

      return true;
    } catch (error: any) {
      return false;
    }
  };*/
  //#region InitnewrowL
  /*const onBeforeAddRowL = (newRow: RowData): boolean => {
    try {
      if (
        !gridApiRef1 ||
        gridApiRef1.current.api.getSelectedNodes().length === 0
      ) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const requiredValuesCheckH = gridApiRef1.current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      return true;
    } catch (error: any) {
      return false;
    }
  };*/

  //#region OnSave
  const onSave = async () => {
    let prdWoTexChanges;
    let prdWoprocTexChanges;
    let prdWobillTexChanges;

    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid3"].current?.stopEditing();

      // Validate required fields (Header)
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheckH) return;

      // Validate required fields (Line)
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current?.requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      // Get changes
      prdWoTexChanges = gridRefs.current["grid1"].current?.getChange();
      prdWoprocTexChanges = gridRefs.current["grid2"].current?.getChange();
      prdWobillTexChanges = gridRefs.current["grid3"].current?.getChange();
      if (
        prdWoTexChanges.modifiedRowcount === 0 &&
        prdWoprocTexChanges.modifiedRowcount === 0 &&
        prdWobillTexChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }

      const headerInserts = prdWoTexChanges.insert ?? [];
      const lineInserts = prdWoprocTexChanges.insert;
      const lineInserts2 = prdWobillTexChanges.insert;
      //신규 등록된 수주건이 있는 경우 채번
      for (let row of headerInserts) {
        if (!row.no_wo) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;
          try {
            // getNoSlip 호출
            const no_wo = await getNoSlip(
              cd_module,
              1, // no_line 값이 필요한 경우 사용
              "WMO", // cd_prefix 값이 필요하다면 여기에 적어주세요.
              row.dt_wo, // 해당 날짜를 넘겨줘야 할 경우
              cd_menu // cd_user 값
            );
            if (no_wo) {
              row.no_wo = no_wo; // no_so 값을 추가

              for (let row of lineInserts) {
                if (!row.no_wo) {
                  if (no_wo) {
                    row.no_wo = no_wo; // no_so 값을 추가
                  }
                }
              }
              for (let row of lineInserts2) {
                if (!row.no_wo) {
                  if (no_wo) {
                    row.no_wo = no_wo; // no_so 값을 추가
                  }
                }
              }
              if (selectedTabPage.current === "1")
                gridRefs.current["grid2"].current.applyFilters({
                  no_wo: no_wo,
                });
              else
                gridRefs.current["grid3"].current.applyFilters({
                  no_wo: no_wo,
                });
            }
            if (row.no_style === null) row.no_style = "";
          } catch (error) {}
        } else {
          const payload = {
            id: "duplication_wo_tex",
            params: { cd_firm: userInfo.cd_firm, no_wo: row.no_wo },
          };
          const noWo_duplication = await fnGetTableById(payload);
          if (noWo_duplication.length > 0) {
            const error = await showDialog(
              "error",
              "작업지시번호가 중복됩니다."
            );
            if (!error) return;
          }
        }
        if (row.no_po !== "" && row.no_po !== undefined) {
          const payload = {
            id: "duplication_wo_tex",
            params: {
              cd_firm: userInfo.cd_firm,
              no_po: row.no_po,
              tp_wo: row.tp_wo,
            },
          };
          const noPo_duplication = await fnGetTableById(payload);
          if (noPo_duplication.length > 0) {
            const confirm = await showDialog(
              "confirm",
              "지시일 " +
                formatYyyyMMdd(noPo_duplication[0].dt_wo) +
                " 기준,\n중복된 PO번호가 존재합니다.\n저장하시겠습니까?"
            );
            if (!confirm) return;
          }
        }
      }
      const allLineRows = [
        ...(prdWoprocTexChanges.insert ?? []),
        ...(prdWoprocTexChanges.update ?? []),
      ];

      for (let row of allLineRows) {
        if (row.st_no_po) {
          let jsInfoObj: any = {};

          jsInfoObj.dc_dlv = row.dc_dlv;
          jsInfoObj.dc_spec = row.dc_spec;
          jsInfoObj.dc_rmk02 = row.dc_rmk02;
          jsInfoObj.dc_rmk03 = row.dc_rmk03;
          jsInfoObj.st_no_po = row.st_no_po;

          row.js_info = jsInfoObj;
        }
      }
      const SaveData = {
        prd_wo_tex: prdWoTexChanges,
        prd_wobill_tex: prdWobillTexChanges,
        prd_woproc_tex: prdWoprocTexChanges,
      };
      await fnSave("SN_PRD_WMO_REG_002_TEX_SAVE_01", SaveData);
      const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();

      if (focusedRow) {
        focusKeyRef.current = {
          no_wo: focusedRow.data.no_wo,
        };
      }
      if (prdWoTexChanges.delete?.length > 0) {
        const sqlQuery1 = {
          sql: `delete from prd_wovariant_tex 
               where cd_firm = :cd_firm
                 and no_wo = :no_wo`,
          cd_firm: userInfo.cd_firm,
          no_wo: prdWoTexChanges.delete[0].no_wo,
        };
        await getTablebySql(sqlQuery1);
      }
      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();

      await onSearch();
      return true;
    } catch (error: any) {
      return false;
    }
  };
  //#endregion

  const onBtnsClick = async (id: string) => {
    //#region BtnaddRow
    if (id === "addRow") {
      onAddRow();
    }
    //#region BtndeleteRow
    if (id === "deleteRow") {
      onDeleteRow();
    }

    if (id === "btnReload") {
      changeReload();
    }
    if (id === "btnDetail") {
      const rowNode = gridRefs.current["grid1"].current.focusedRowNode();
      const sqlQuery1 = {
        sql: `select 1 from PRD_WOPROC_tex where cd_firm = :cd_firm and no_wo = :no_wo`,
        cd_firm: userInfo.cd_firm,
        no_wo: rowNode.data.no_wo,
      };
      const data = await getTablebySql(sqlQuery1);
      if (data.length > 0) {
        const focusedRowNode =
          gridRefs.current["grid2"].current?.focusedRowNode();
        if (focusedRowNode.data.cd_op === "T110") {
          await showDialog("alert", "편직 공정은 사용하지 않습니다.");
          return;
        }

        const selectedData = {
          ...focusedRowNode,
          qt_dummy01: rowNode?.data?.qt_dummy01 ?? 0,
          qt_dummy04: rowNode?.data?.qt_dummy04 ?? 0,
        };
        const component = (
          <SN_PRD_WMO_REG_002_TEX_POP_001 selectedData={selectedData} />
        );
        const result = await showPopupModal({
          title: "상세내역",
          children: component,
          validation: false,
          width: "59%",
          height: "60%",
          okayBtn: true,
          closeBtn: true,
        });
        if (!result || result === "close") return;
        let sumQtwo = 0,
          sumQtdivide = 0;
        result.forEach((row: any) => {
          sumQtwo += row.qt ?? 0;
          sumQtdivide += row.qt_divide ?? 0;
        });
        focusedRowNode.setDataValue("qt_wo", sumQtwo);
        focusedRowNode.setDataValue("qt_divide", sumQtdivide);
      } else {
        await showDialog(
          "alert",
          "작업지시를 저장한 뒤에 사용하실 수 있습니다."
        );
        return;
      }
    }
  };
  const changeReload = async () => {
    const rowNode = gridRefs.current["grid1"].current.focusedRowNode();
    let cdWh: any;
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      if (!cdWh) cdWh = node.data.cd_cust;
    });
    if (selectedTabPage.current === "1") {
      if (gridRefs.current["grid2"].current.getDisplayedRowCount() !== 0) {
        const confirm = await showDialog(
          "confirm",
          "기존 공정정보를 삭제하고 다시 생성합니다.\n전개 하시겠습니까?"
        );
        if (!confirm) return;
      }
      gridRefs.current["grid2"].current?.deleteAllRows();

      const payload = {
        id: "duplication_wo_tex",
        params: { cd_firm: userInfo.cd_firm, no_wo: rowNode.data.no_wo },
      };
      const noWo_duplication = await fnGetTableById(payload);
      if (noWo_duplication.length > 0) {
        isProgrammaticChangeRef.current = true;
        rowNode.setDataValue("cd_item", "", "noEvent");
        rowNode.setDataValue("no_wo", "", "noEvent");
        await showDialog(
          "warning",
          "중복된 작업지시번호입니다.\n 작업지시번호를 다시 입력 후 품목을 선택해 주세요"
        );
        setTimeout(() => {
          isProgrammaticChangeRef.current = false;
        }, 0);
        return;
      }
      const rout = {
        id: "rout",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_item: rowNode.data.cd_item,
          tp_rout: "A",
          cd_rout: rowNode.data.cd_rout,
        },
      };
      const search_rout = await fnGetTableById(rout);
      let dt1: any, dt2: any;
      dt2 = search_rout;
      if (dt2.length > 0) {
        rowNode.setDataValue("cd_rout", dt2[0].cd_rout, "noEvent");
        rowNode.setDataValue("nm_rout", dt2[0].nm_rout, "noEvent");
        rowNode.setDataValue("cd_wo", dt2[0].cd_wo);
        rowNode.setDataValue("st_wo", dt2[0].st_wo, "noEvent");
        rowNode.setDataValue("yn_autorel", dt2[0].yn_autorel, "noEvent");
        const rout_op = {
          id: "rout_op",
          params: {
            cd_firm: userInfo.cd_firm,
            cd_rout: dt2[0].cd_rout,
          },
        };
        const search_rout_op = await fnGetTableById(rout_op);
        dt1 = search_rout_op;
        if (dt1.length > 0) {
          const isSingleProcess = dt1.length === 1;
          rowNode.setDataValue(
            "qt_dummy01",
            isSingleProcess
              ? 1
              : Math.round(
                  (dt2[0].qt_weight / 1000) * dt2[0].qt_dummy01 * 0.023225 * 100
                ) / 100,
            "noEvent"
          );
          const rowCount =
            gridRefs.current["grid2"].current?.getDisplayedRowCount();
          if (rowCount > 0) {
            for (var i = 0; i < rowCount; i++) {
              gridRefs.current["grid2"].current?.deleteRowByIndex(i);
            }
          }
          // const selectNode = gridApiRef1.current.api.getSelectedNodes()[0];
          // let selectedRows = gridApiRef1.current.api.getSelectedNodes();
          const selectNode = gridRefs.current["grid1"].current.focusedRowNode();
          let maxNoLine =
            gridRefs.current["grid2"].current.getMaxValue("no_line");

          dt1.forEach((row: any, index: number) => {
            if (index === 0) cdWh = row.cd_cust_sct;
            const newRow = {
              cd_firm: userInfo.cd_firm,
              no_wo: selectNode.data?.no_wo,
              cd_op: row.cd_op,
              nm_op: row.nm_op,
              fg_op: row.fg_op,
              yn_end: row.yn_end,
              dc_unit: isSingleProcess
                ? selectNode.data?.dc_item_unit
                : row.yn_end === "Y"
                  ? "YD"
                  : "KG",
              yn_sct: row.yn_sct,
              cd_cust: row.cd_cust_sct,
              nm_cust_sort: row.nm_cust_sort,
              qt_wo: selectNode.data?.qt_wo,
              qt_divide: selectNode.data?.qt_divide,
              dt_wo: todayform,
              dt_dlv: todayform,
              no_line: maxNoLine + 1,
              yn_work: "Y",
              st_proc: dt2[0].st_wo,
            };
            gridRefs.current["grid2"].current.addRow(newRow);
            maxNoLine++;
          });
          const wh = {
            id: "wh",
            params: { cd_firm: userInfo.cd_firm, cd_wh: cdWh },
          };
          const search_wh = await fnGetTableById(wh);
          if (search_wh.length < 0) {
            const error = await showDialog(
              "error",
              "외주처 창고를 등록해 주세요"
            );
            if (!error) return;
          }
          if (!isSingleProcess) {
            const calcValue =
              (rowNode.data.qt_wo || 0) / (rowNode.data.qt_dummy01 || 0);
            gridRefs.current["grid2"].current.forEachFilteredNode(
              (node: RowNode) => {
                if ("Y" === node.data.yn_end)
                  node.setDataValue("qt_wo", Math.floor(calcValue), "noEvent");
              }
            );
          }
        }
      } else {
        await showDialog("alert", "공정품목등록에 존재하지 품목입니다.");
        return;
      }
    } else {
      if (gridRefs.current["grid3"].current.getDisplayedRowCount() !== 0) {
        const confirm = await showDialog(
          "confirm",
          "기존 자재정보를 삭제하고 다시 생성합니다.\n전개 하시겠습니까?"
        );
        if (!confirm) return;
      }
      gridRefs.current["grid3"].current?.deleteAllRows();
      const boml = {
        id: "boml",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_item: rowNode.data.cd_item,
        },
      };
      const search_boml = await fnGetTableById(boml);
      const data = search_boml;
      let selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
      const allRowData: any[] = []; // 라인에 있는 데이터들
      gridRefs.current["grid3"].current?.forEachFilteredNode((node: any) => {
        allRowData.push(node.data);
      });
      let maxNoLine = gridRefs.current["grid3"].current.getMaxValue("no_line");
      if (data.length > 0) {
        data.forEach((row: any) => {
          const newRow = {
            cd_firm: userInfo.cd_firm,
            no_wo: selectedRows.data.no_wo,
            cd_wh: cdWh,
            cd_op: row.cd_op,
            cd_matl: row.cd_matl,
            nm_matl: row.nm_item,
            dc_item_unit: row.dc_item_unit,
            cd_dummy01: row.cd_dummy02,
            qt_unit: row.qt_need,
            qt_need: row.qt_need * rowNode.data.qt_wo,
            no_line: maxNoLine + 1,
            dt_dlv: todayform,
            yn_bf: "Y",
          };
          gridRefs.current["grid3"].current?.addRow(newRow);
          maxNoLine++;
        });
      } else {
        await showDialog("alert", "자재정보 탭에 BOM 정보가 없습니다.");
        return;
      }
    }
  };
  //#region Filter
  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      publishChatSelection(selectedRow);
      const isNew = selectedRow?._isNew === true;
      setIsNewRow(isNew);
      const no_wo = selectedRow.no_wo;
      gridRefs.current["grid2"].current?.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid2"].current?.selectAndFocusRow(0);
      gridRefs.current["grid3"].current?.applyFilters({ no_wo: no_wo });
      gridRefs.current["grid3"].current?.selectAndFocusRow(0);
      _nm_rout_old.current = selectedRow.cd_rout;
      _cd_item_old.current = selectedRow.cd_item;

      setSelectedDocu(no_wo);
    } else {
      publishChatSelection(null);
      return;
    }
  };

  // const onRowClicked3 = (event: any) => {
  //   isYnEnd.current = true;
  // };
  const onSelectionChanged = (event: any) => {
    isYnEnd.current = true;
  };
  const TabChangedEvent = async (index: any) => {
    setActiveTab(index);
    selectedTabPage.current = index;
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() === 0) return;
    const rowNode = gridRefs.current["grid1"].current.focusedRowNode();
    if (selectedTabPage.current === "1") {
      gridRefs.current["grid2"].current?.applyFilters({
        no_wo: rowNode.data.no_wo,
      });
    } else {
      gridRefs.current["grid3"].current?.applyFilters({
        no_wo: rowNode.data.no_wo,
      });
    }
  };
  const onRowClicked = (event: any) => {
    publishChatSelection(event.data);
    _nm_rout_old.current = event.data?.cd_rout;
    _cd_item_old.current = event.data?.cd_item;
  };
  const onCellDoubleClicked = async (event: any) => {
    const selectedData = gridRefs.current["grid2"].current.focusedRowNode();
    if (event.colDef.field === "dc_dlv") {
      const component = (
        <SN_PRD_WMO_REG_002_TEX_POP_002 selectedData={selectedData} />
      );
      const result = await showPopupModal({
        title: "의뢰서",
        children: component,
        validation: false,
        width: "55%",
        height: "55%",
        okayBtn: true,
        closeBtn: true,
        checkData: false, // 확인버튼 눌렀을때 error 안뜨게
      });
      if (!result || result === "close") return;
      setTimeout(() => {
        event.node.setDataValue("dc_dlv", result.dc_dlv, "noEvent");
      }, 0);
      gridRefs.current["grid2"].current?.stopEditing();
    }
  };
  //#region CellChanged1
  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;
    if (isProgrammaticChangeRef.current) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    let dt1: any, dt2: any;
    if (isRestoring.current) {
      // 되돌리는 중이면 이벤트 무시
      isRestoring.current = false;
      return;
    }
    if (colId === "no_wo") {
      let cnt1 = 0;
      let cnt2 = 0;
      gridRefs.current["grid2"].current?.forEachFilteredNode((node: any) => {
        if (node.data?.no_wo === event.oldValue) cnt1++;
      });

      gridRefs.current["grid3"].current?.forEachFilteredNode((node: any) => {
        if (node.data?.no_wo === event.oldValue) cnt2++;
      });

      if (cnt1 > 0 || cnt2 > 0) {
        const confirm = await showDialog(
          "confirm",
          "지시번호를 변경하시면, 처음부터 값을 다시 입력하셔야 합니다. \n변경하시겠습니까?"
        );
        if (!confirm) {
          isRestoring.current = true;
          rowNode.setDataValue(colId, event.oldValue);
          publishChatSelection({ ...rowData, no_wo: event.oldValue });
          gridRefs.current["grid1"].current?.resetUpdate(true);
          gridRefs.current["grid2"].current?.resetUpdate(true);
          gridRefs.current["grid3"].current?.resetUpdate(true);

          setTimeout(() => {
            gridRefs.current["grid1"].current.setFocusedCell(
              event.rowIndex,
              colId
            );
          }, 0);

          return;
        }
        gridRefs.current["grid3"].current?.deleteAllRows();
        gridRefs.current["grid2"].current?.deleteAllRows();
      }
    } else if (colId === "cd_item") {
      reload(rowNode);
    } else if (colId === "cd_rout") {
      changeReload();
    } else if (colId === "qt_wo") {
      const calcValue = (rowData.qt_wo || 0) / (rowData.qt_dummy01 || 0);
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("qt_wo", rowData.qt_wo);
        if ("Y" === node.data.yn_end)
          node.setDataValue("qt_wo", Math.floor(calcValue));
      });
      gridRefs.current["grid3"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("qt_need", node.data.qt_unit * rowData.qt_wo);
      });
    } else if (colId === "qt_divide") {
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("qt_divide", rowData.qt_divide);
      });
    } else if (colId === "cd_wo") {
      const sqlQuery1 = {
        sql: `select yn_autorel,yn_autorcv, case when coalesce(yn_autorel,'N') = 'Y' then 'R' else 'F' END AS st_wo from mas_wotype where cd_firm = :cd_firm and cd_wo = :cd_wo`,
        cd_firm: userInfo.cd_firm,
        cd_wo: rowData.cd_wo,
      };
      let data = await getTablebySql(sqlQuery1);
      rowNode.setDataValue("yn_autorcv", data[0].yn_autorcv);
      rowNode.setDataValue("yn_autorel", data[0].yn_autorel);
      rowNode.setDataValue("st_wo", data[0].st_wo);
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("st_proc", data[0].st_wo);
      });
    } else if (colId === "qt_dummy01") {
      const calcValue = (rowData.qt_wo || 0) / (rowData.qt_dummy01 || 0);
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        if ("Y" === node.data.yn_end)
          node.setDataValue("qt_wo", Math.floor(calcValue));
      });
    } else if (colId === "no_po") {
      const sqlQuery1 = {
        sql: `select no_style,nm_style from mas_styleh_tex where cd_firm = :cd_firm and no_reference = :no_po order by tm_reg desc limit 1`,
        cd_firm: userInfo.cd_firm,
        no_po: rowData.no_po,
      };
      let data = await getTablebySql(sqlQuery1);
      if (data.length > 0) {
        rowNode.setDataValue("dc_dummy01", data[0].no_style);
        rowNode.setDataValue("nm_style", data[0].nm_style);
      }
    }
    publishChatSelection(rowNode.data);
  };

  //#region CellChanged2

  //#region onActivate
  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: nodeData.cd_firm,
        cd_biz: nodeData.cd_biz,
        dt_from: nodeData.dt_woreq,
        dt_to: nodeData.dt_woreq,
      };
      setFormData(selectedData);
      onSearch();
    } else if ((Menuprops.figure as string) === "fg_drilldown.Registration") {
      const modifiedRowsH = gridRefs.current["grid1"].current?.getChange();
      const modifiedRowsL = gridRefs.current["grid2"].current?.getChange();
      if (
        modifiedRowsH.modifiedRowcount > 0 ||
        modifiedRowsL.modifiedRowcount > 0
      ) {
        const confirm = await showDialog(
          "confirmCancel",
          "수정된 내용이 있습니다. 저장하시겠습니까?"
        );
        if (confirm === true) {
          await onSave();
          await setDrilldown();
          return;
        } else if (confirm === false) {
          gridRefs.current["grid1"].current?.resetUpdate();
          gridRefs.current["grid2"].current?.resetUpdate();
          await setDrilldown();
          return;
        } else {
          return;
        }
      } else {
        await setDrilldown();
      }
    }
  };
  const [isDrilldownActive, setIsDrilldownActive] = useState(false);

  const setDrilldown = async () => {
    setIsDrilldownActive(true);
    const drill = {
      cd_firm: userInfo?.cd_firm,
      no_so: Menuprops.nodeData[0],
      no_line: Menuprops.nodeData[1],
    };

    const param = {
      id: "sn_prd_wmo_reg_002_tex_searchrefso",
      params: drill,
    };
    const data = await fnGetDataSet(param);

    const headerResult = data[0];

    if (headerResult) {
      await onInsert();
      const rowCount =
        gridRefs.current["grid1"].current?.getDisplayedRowCount();
      const lastRowIndex = rowCount - 1;
      const lastRowNode =
        gridRefs.current["grid1"].current?.getRowNodeAtIndex(lastRowIndex);
      lastRowNode?.setSelected(true);
      if (lastRowNode) {
        for (const key in headerResult[0]) {
          if (headerResult[0][key]) {
            lastRowNode.setDataValue(key, headerResult[0][key]);
          }
        }
      }
    }
    setIsDrilldownActive(false);
  };

  //#region OnPopMenu
  const handleContextMenu = async (params: any) => {
    const getRenderedRows = gridRefs.current["grid1"].current?.focusedRowNode();
    switch (params) {
      case "fn_sn_prd_com_wmo_reg_04":
        const selectedDataH =
          gridRefs.current["grid1"].current.getSelectedRows()[0];
        const returnData = [selectedDataH.no_wo, selectedDataH.dt_wo];

        const drillDown = menuItems
          ? menuItems.find(
              (item: any) => item?.cd_menu === "SN_PRD_WMO_REG_002"
            )
          : undefined;

        if (drillDown) {
          const filePath =
            `./${drillDown.cd_module}/${drillDown.cd_menu}/${drillDown.cd_menu}`.toUpperCase();

          (window as any).onActivate(
            drillDown.cd_menu,
            drillDown.nm_menu,
            drillDown.cd_module,
            filePath,
            drillDown,
            drillDown.nm_path,
            returnData,
            "fg_drilldown.Search"
          );
        }
        break;

      case "wf_sn_confirm": //마감처리
        for (const node of getRenderedRows) {
          if (node.isSelected()) {
            if (node.data?.st_wo === "C") {
              showDialog("error", "처리 실패. 미마감인건이 없습니다.");
              return;
            }
            gridRefs.current["grid1"].current?.setValue(node, "st_wo", "C");
            await onSave();
          }
        }
        break;

      case "wf_sn_confirm_cancel": //마감취소
        for (const node of getRenderedRows) {
          if (node.isSelected()) {
            if (node.data?.qt_work !== 0) {
              if (node.data?.st_wo === "S") {
                showDialog("error", "처리 실패. 미마감인건이 없습니다.");
                return;
              }
              if (node.data?.qt_rcv > 0) {
                const confirm = await showDialog(
                  "confirm",
                  "작업지시(" +
                    node.data?.no_wo +
                    ")는 입고수량이 등록되어 있습니다.\n마감취소 하시겠습니까?"
                );
                if (!confirm) return;
              }
              gridRefs.current["grid1"].current?.setValue(node, "st_wo", "S");
            } else if (
              node.data?.qt_work === 0 &&
              node.data?.yn_autorel === "N"
            ) {
              if (node.data?.st_wo === "R") {
                showDialog("error", "처리 실패. 마감인건이 없습니다.");
                return;
              }
              if (node.data?.qt_rcv > 0) {
                const confirm = await showDialog(
                  "confirm",
                  "작업지시(" +
                    node.data?.no_wo +
                    ")는 입고수량이 등록되어 있습니다.\n마감취소 하시겠습니까?"
                );
                if (!confirm) return;
              }
              gridRefs.current["grid1"].current?.setValue(node, "st_wo", "R");
            } else {
              showDialog("error", "처리 실패. 마감인건이 없습니다.");
              return;
            }
          }
        }
        await onSave();
        break;
    }
  };
  const reload = async (rowNode: any) => {
    if (gridRefs.current["grid2"].current.getDisplayedRowCount() !== 0) {
      const confirm = await showDialog(
        "confirm",
        "기존 공정정보를 삭제하고 다시 생성합니다.\n전개 하시겠습니까?"
      );
      if (!confirm) return;
    }
    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid3"].current?.deleteAllRows();

    const payload = {
      id: "duplication_wo_tex",
      params: { cd_firm: userInfo.cd_firm, no_wo: rowNode.data.no_wo },
    };
    const noWo_duplication = await fnGetTableById(payload);
    if (noWo_duplication.length > 0) {
      isProgrammaticChangeRef.current = true;
      rowNode.setDataValue("cd_item", "", "noEvent");
      rowNode.setDataValue("no_wo", "", "noEvent");
      await showDialog(
        "warning",
        "중복된 작업지시번호입니다.\n 작업지시번호를 다시 입력 후 품목을 선택해 주세요"
      );
      setTimeout(() => {
        isProgrammaticChangeRef.current = false;
      }, 0);
      return;
    }
    const rout = {
      id: "rout",
      params: {
        cd_firm: userInfo.cd_firm,
        cd_item: rowNode.data.cd_item,
        tp_rout: "A",
      },
    };
    const search_rout = await fnGetTableById(rout);
    let dt1: any, dt2: any;
    dt2 = search_rout;
    let cdWh = "";
    const selectNode = gridRefs.current["grid1"].current.focusedRowNode();
    if (dt2.length > 0) {
      rowNode.setDataValue("cd_rout", dt2[0].cd_rout, "noEvent");
      rowNode.setDataValue("nm_rout", dt2[0].nm_rout, "noEvent");
      rowNode.setDataValue("cd_wo", dt2[0].cd_wo);
      rowNode.setDataValue("st_wo", dt2[0].st_wo, "noEvent");
      rowNode.setDataValue("yn_autorel", dt2[0].yn_autorel, "noEvent");
      const rout_op = {
        id: "rout_op",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_rout: dt2[0].cd_rout,
        },
      };
      const search_rout_op = await fnGetTableById(rout_op);
      dt1 = search_rout_op;

      if (dt1.length > 0) {
        const isSingleProcess = dt1.length === 1;
        rowNode.setDataValue(
          "qt_dummy01",
          isSingleProcess
            ? 1
            : Math.round(
                (dt2[0].qt_weight / 1000) * dt2[0].qt_dummy01 * 0.023225 * 100
              ) / 100,
          "noEvent"
        );
        const rowCount =
          gridRefs.current["grid2"].current?.getDisplayedRowCount();
        if (rowCount > 0) {
          for (var i = 0; i < rowCount; i++) {
            gridRefs.current["grid2"].current?.deleteRowByIndex(i);
          }
        }
        // const selectNode = gridApiRef1.current.api.getSelectedNodes()[0];
        // let selectedRows = gridApiRef1.current.api.getSelectedNodes();

        let maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");

        dt1.forEach((row: any, index: number) => {
          if (index === 0) cdWh = row.cd_cust_sct;
          const newRow = {
            cd_firm: userInfo.cd_firm,
            no_wo: selectNode.data?.no_wo,
            cd_op: row.cd_op,
            nm_op: row.nm_op,
            fg_op: row.fg_op,
            yn_end: row.yn_end,
            dc_unit: isSingleProcess
              ? selectNode.data?.dc_item_unit
              : row.yn_end === "Y"
                ? "YD"
                : "KG",
            yn_sct: row.yn_sct,
            cd_cust: row.cd_cust_sct,
            nm_cust_sort: row.nm_cust_sort,
            qt_wo: selectNode.data?.qt_wo,
            qt_divide: selectNode.data?.qt_divide,
            dt_wo: todayform,
            dt_dlv: todayform,
            no_line: maxNoLine + 1,
            yn_work: "Y",
            st_proc: dt2[0].st_wo,
          };
          gridRefs.current["grid2"].current.addRow(newRow);
          maxNoLine++;
        });
        const wh = {
          id: "wh",
          params: { cd_firm: userInfo.cd_firm, cd_wh: cdWh },
        };
        const search_wh = await fnGetTableById(wh);
        if (search_wh.length < 0) {
          const error = await showDialog(
            "error",
            "외주처 창고를 등록해 주세요"
          );
          if (!error) return;
        }
        if (!isSingleProcess) {
          const calcValue =
            (rowNode.data.qt_wo || 0) / (rowNode.data.qt_dummy01 || 0);
          gridRefs.current["grid2"].current.forEachFilteredNode(
            (node: RowNode) => {
              if ("Y" === node.data.yn_end)
                node.setDataValue("qt_wo", Math.floor(calcValue), "noEvent");
            }
          );
        }
      }
    } else {
      await showDialog("alert", "공정품목등록에 존재하지 품목입니다.");
      return;
    }
    const boml = {
      id: "boml",
      params: {
        cd_firm: userInfo.cd_firm,
        cd_item: rowNode.data.cd_item,
      },
    };
    const search_boml = await fnGetTableById(boml);
    const data2 = search_boml;

    let maxNoLine1 = gridRefs.current["grid3"].current.getMaxValue("no_line");
    if (data2.length > 0) {
      data2.forEach((row: any) => {
        const newRow = {
          cd_firm: userInfo.cd_firm,
          no_wo: rowNode.data?.no_wo,
          cd_op: row.cd_op,
          cd_wh: cdWh,
          cd_matl: row.cd_matl,
          nm_matl: row.nm_item,
          dc_item_unit: row.dc_item_unit,
          cd_dummy01: row.cd_dummy02,
          qt_unit: row.qt_need,
          qt_need: row.qt_need * rowNode.data.qt_wo,
          dt_dlv: todayform,
          no_line: maxNoLine1 + 1,
          yn_bf: "Y",
        };
        gridRefs.current["grid3"].current?.addRow(newRow);
        maxNoLine1++;
      });
    } else {
      await showDialog("alert", "자재정보 탭에 BOM 정보가 없습니다.");
      return;
    }
    gridRefs.current["grid2"].current.applyFilters({
      no_wo: rowNode.data?.no_wo,
    });
    gridRefs.current["grid3"].current.applyFilters({
      no_wo: rowNode.data?.no_wo,
    });
  };

  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_wo === focusKey.no_wo) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged: onFocusedRowChanged,
          onRowClicked: onRowClicked,
          onCellValueChanged: onCellValueChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onContextMenu: handleContextMenu,
          onCellDoubleClicked: onCellDoubleClicked,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onSelectionChanged: onSelectionChanged,
          onContextMenu: handleContextMenu,
        },
      },
    }),
    [columns, dataSources]
  );
  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        />
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              title: "작업지시",
            }}
            events={grids.grid1.events}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["공정정보", "자재정보"]}
            width={"100%"}
            onTabChanged={TabChangedEvent}
            header={[
              <SnTabHeader
                body={
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"상세내역"}
                      onClick={() => {
                        onBtnsClick("btnDetail");
                      }}
                    />
                    <SnButton
                      text={"전개"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
              />,
              <SnTabHeader
                body={
                  <div>
                    <SnButton
                      text={"전개"}
                      onClick={() => {
                        onBtnsClick("btnReload");
                      }}
                    />
                  </div>
                }
                onBtnAddClick={onBtnsClick}
                onBtnDeleteClick={onBtnsClick}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                events={grids.grid2.events}
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,

              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                etcProps={{
                  isEditable: true,
                  rowSelection: "single",
                }}
              />,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WMO_REG_002_TEX;
